class GravityForms {
	constructor() {
		this.formEls = document.querySelectorAll(".gform_wrapper");

		this.formEls.forEach(item => {
			this.addCustomSpinner(item);
			this.createCustomFileInputs(item);
		});

		if (typeof jQuery === "function") {
			jQuery(document).on("gform_confirmation_loaded", this.onConfirmationLoaded.bind(this));
		}
	}

	/**
	 *
	 * @param {HTMLElement} formWrapper
	 */
	addCustomSpinner(formWrapper) {
		const footerEl = formWrapper.querySelector(".gform_footer");
		const footerObserver = new MutationObserver((records) => {
			records.forEach(rec => {
				if (rec.addedNodes.length > 0) {
					rec.addedNodes.forEach(node => {
						if (node.classList.contains("gform_ajax_spinner")) {
							const btnEl = formWrapper.querySelector(".gform_submit_button");
							btnEl.classList.add("has-spinner");
							btnEl.append(node);
						}
					});
				}
			});
		});

		const formObserver = new MutationObserver((records) => {
			if (this.wasSubmitted(records)) {
				this.addCustomSpinner(formWrapper); // since the DOM is rebuilt after submission
			}
		});

		footerObserver.observe(footerEl, {childList: true});
		formObserver.observe(formWrapper, {childList: true});
	}

	/**
	 * @param {MutationRecord[]} records
	 * @return {boolean}
	 */
	wasSubmitted(records) {
		let out = false;
		records.forEach(rec => {
			if (rec.addedNodes.length > 0) {
				rec.addedNodes.forEach(node => {
					if (node instanceof HTMLFormElement) {
						out = true;
					}
				});
			}
		});

		return out;
	}

	/**
	 * @param {HTMLElement} formWrapper
	 */
	createCustomFileInputs(formWrapper) {

		/**
		 * @type {NodeListOf<HTMLInputElement>}
		 */
		const fileInputEls = formWrapper.querySelectorAll("input[type=file]");
		if (fileInputEls.length === 0) {
			return;
		}

		fileInputEls.forEach(
			input => {
				/**
				 *
				 * @type {HTMLLabelElement}
				 */
				const labelElement = input.closest("form").querySelector("label[for=" + input.id + "]");
				const overlayEl = document.createElement("div");
				let label = "";
				if (labelElement) {
					label = labelElement.innerHTML;
					labelElement.style.display = "none";
				}
				else {
					label = "Browse...";
				}

				overlayEl.classList.add("upload-overlay");
				overlayEl.innerHTML = label;

				input.after(overlayEl);

				input.addEventListener("change", (e) => {
					const path = input.value;
					const dirSeparator = path.indexOf("\\") > -1 ? "\\" : "/";
					input.nextElementSibling.innerHTML = path.split(dirSeparator).pop();
				});
			}
		);
	}

	/**
	 * @param {HTMLElement} element
	 * @returns {HTMLElement}
	 */
	getOffsetParent(element) {
		if (element) {
			const parent = element.offsetParent;
			if (parent.nodeName !== "BODY") {
				return this.getOffsetParent(parent);
			}

			return element;
		}

		return null;
	}

	/**
	 * @param {Event} e
	 * @param {number} formId
	 */
	onConfirmationLoaded(e, formId) {
		let targetEl = this.getOffsetParent(window.document.getElementById(`gform_confirmation_wrapper_${formId}`));
		if (targetEl) {
			const headerHeight = thee.getHeaderController().getHeight();
			const scrollTo = targetEl.offsetTop - headerHeight;
			window.scrollTo({
				top: scrollTo,
				behavior: "smooth"
			});

		}
	}
}

export default GravityForms;
